import API from "../../../../../global/api";

export const requestPreliminaryFinal = (data) => {
  return {
    type: "REQUEST_PRELIMINARY_FINAL",
  };
};
export const successPreliminaryFinal = (data) => {
  return {
    type: "SUCCESS_PRELIMINARY_FINAL",
    payload: data,
  };
};
export const errorPreliminaryFinal = (data) => {
  return {
    type: "ERROR_PRELIMINARY_FINAL",
    payload: data,
  };
};

export const putPreliminaryFinal = (data) => {
  return (dispatch) => {
    API.put(`/disclose_financials/dividing-property-debt`, data).then((res) => {
      dispatch(successPreliminaryFinal(data));
    });
  };
};



export const requestDisclosureForms = (data) => {
  return {
    type: "REQUEST_DISCLOSURE_FORMS",
  };
};
export const successDisclosureForms = (data) => {
  return {
    type: "SUCCESS_DISCLOSURE_FORMS",
    payload: data,
  };
};
export const errorDisclosureForms = (data) => {
  return {
    type: "ERROR_DISCLOSURE_FORMS",
    payload: data,
  };
};
export const putDisclosureForms = (data) => {
  return (dispatch) => {
    API.put(`/disclose_financials/preliminary-disclosures`, data).then((res) => {
      dispatch(successDisclosureForms(data));
    });
  };
};




export const requestDisclosureProvided = (data) => {
  return {
    type: "REQUEST_DISCLOSURE_PROVIDED",
  };
};
export const successDisclosureProvided = (data) => {
  return {
    type: "SUCCESS_DISCLOSURE_PROVIDED",
    payload: data,
  };
};
export const errorDisclosureProvided = (data) => {
  return {
    type: "ERROR_DISCLOSURE_PROVIDED",
    payload: data,
  };
};
export const putDisclosureProvided = (data) => {
  return (dispatch) => {
    API.put(`/disclose_financials/provide-disclosures`, data).then((res) => {
      dispatch(successDisclosureProvided(data));
    });
  };
};



export const requestDateDisclosure = (data) => {
  return {
    type: "REQUEST_DATE_DISCLOSURE",
  };
};
export const successDateDisclosure = (data) => {
  return {
    type: "SUCCESS_DATE_DISCLOSURE",
    payload: data,
  };
};
export const errorDateDisclosure = (data) => {
  return {
    type: "ERROR_DATE_DISCLOSURE",
    payload: data,
  };
};


export const putDateDisclosure = (data) => {
  return (dispatch) => {
    API.put(`/disclose_financials/dissolution-date`, data).then(
      (res) => {
        dispatch(successDateDisclosure(data));
      }
    );
  };
};




export const requestWaiveFinalDisclosure = (data) => {
  return {
    type: "REQUEST_WAIVE_FINAL_DISCLOSURE",
  };
};
export const successWaiveFinalDisclosure = (data) => {
  return {
    type: "SUCCESS_WAIVE_FINAL_DISCLOSURE",
    payload: data,
  };
};
export const errorWaiveFinalDisclosure = (data) => {
  return {
    type: "ERROR_WAIVE_FINAL_DISCLOSURE",
    payload: data,
  };
};

export const putWaiveFinalDisclosure = (data) => {
  return (dispatch) => {
    API.put(`/disclose_financials/waive-disclosure`, data).then((res) => {
      dispatch(successWaiveFinalDisclosure(data));
    });
  };
};


export const requestWishToWaiveFinal = (data) => {
  return {
    type: "REQUEST_WISH_TO_WAIVE",
  };
};
export const successWishToWaiveFinal = (data) => {
  return {
    type: "SUCCESS_WISH_TO_WAIVE",
    payload: data,
  };
};
export const errorWishToWaiveFinal = (data) => {
  return {
    type: "ERROR_WISH_TO_WAIVE",
    payload: data,
  };
};

export const putWishToWaiveFinal = (data) => {
  return (dispatch) => {
    API.put(`/disclose_financials/spouse-agree`, data).then((res) => {
      dispatch(successWishToWaiveFinal(data));
    });
  };
};





export const requestAllFormData = () => {
  return {
    type: "REQUEST_ALL_FORM_DATA",
  };
};
export const successAllFormData = (data) => {
  return {
    type: "SUCCESS_ALL_FORM_DATA",
    payload: data,
  };
};
export const errorAllFormData = () => {
  return {
    type: "ERROR_ALL_FORM_DATA",
  };
};


export const getAllFormData = (data1) => {
  return (dispatch) => {
       dispatch(requestAllFormData());
    API.post(`/disclose_financials/get-disclose-financials`,data1).then((res) => {
      dispatch(successAllFormData(res.data));
    }).catch(err => {
      dispatch(errorAllFormData());
    })
  };
};

//POST CALL

export const requestPostFormData = () => {
  return {
    type: "REQUEST_POST_FORM_DATA",
  };
};
export const successPostFormData = (data) => {
  return {
    type: "SUCCESS_POST_FORM_DATA",
    payload: data,
  };
};
export const errorPostFormData = () => {
  return {
    type: "ERROR_POST_FORM_DATA",
  };
};

export const postFormData = (data) => {
  return (dispatch) => {
    API.post(`/disclose_financials/post-disclose-financials`,data).then((res) => {
      dispatch(successPostFormData(data));
    });
  };
};